import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import DefaultTemplateContainer from '../../containers/DefaultDeviseTemplateContainer'
import {
    getApplicationForAdmission,
    logoutAction
} from '../../actions'
import './DashboardContainer.css';

class DoshboardBox extends React.Component {

    componentDidMount() {
        this.props.getApplicationForAdmission()
    }

    render() {
        return (
            <DefaultTemplateContainer
                htmlBody={this.indexButtion()}
            />
        )
    }

    indexButtion() {
        const { sectionLocksLoaded } = this.props
        const sections = [
            {
                key: 'application',
                title: '入學申請書',
                description: '填寫學生基本資料、家庭資料與上傳學生大頭照。',
                path: '/application_for_admission',
                locked: this.props.applicationLocked,
                submitted: this.props.applicationSubmitted,
            },
            {
                key: 'parental',
                title: '學生暨家長身份調查表',
                description: '填寫學生與家長身份別與相關補助資格。',
                path: '/parental_status_survey',
                locked: this.props.parentalLocked,
                submitted: this.props.parentalSubmitted,
            },
            {
                key: 'health',
                title: '學童健康調查表',
                description: '建立健康史與照護需求資料，供學校參考。',
                path: '/health_questionnaire',
                locked: this.props.healthLocked,
                submitted: this.props.healthSubmitted,
            },
            {
                key: 'transfer',
                title: '學生輔導紀錄資料',
                description: '填寫家庭狀況與學生輔導相關背景資料。',
                path: '/transfer_student',
                locked: this.props.transferLocked,
                submitted: this.props.transferSubmitted,
            },
            {
                key: 'parent_pass',
                title: '家長接送證',
                description: '上傳家長接送資料與證件照片。',
                path: '/parent_pass',
                locked: this.props.parentPassLocked,
                submitted: this.props.parentPassSubmitted,
            },
        ]

        const summary = this.buildSummary(sections, sectionLocksLoaded)

        return (
            <div className='admission-dashboard'>
                <div className='admission-dashboard__hero'>
                    <div>
                        <p className='admission-dashboard__eyebrow'>新生入學填報系統</p>
                        <h2 className='admission-dashboard__title'>請依序完成下列表單</h2>
                        <p className='admission-dashboard__subtitle'>
                            表單送出後仍可修改，直到註冊組確認完成。若表格填寫不完整，註冊組將電聯通知，敬請重新填寫後再送出。
                        </p>
                    </div>
                    <div className='admission-dashboard__progress'>
                        <span className='admission-dashboard__progress-label'>完成度</span>
                        <strong className='admission-dashboard__progress-value'>
                            {sectionLocksLoaded ? `${summary.completed}/${summary.total}` : '--/--'}
                        </strong>
                    </div>
                </div>

                <div className='admission-dashboard__stats'>
                    <div className='admission-dashboard__stat-card is-complete'>
                        <span>註冊組確認完成</span>
                        <strong>{sectionLocksLoaded ? summary.completed : '--'}</strong>
                    </div>
                    <div className='admission-dashboard__stat-card is-submitted'>
                        <span>家長完成填寫</span>
                        <strong>{sectionLocksLoaded ? summary.submitted : '--'}</strong>
                    </div>
                    <div className='admission-dashboard__stat-card is-pending'>
                        <span>尚未填寫</span>
                        <strong>{sectionLocksLoaded ? summary.pending : '--'}</strong>
                    </div>
                </div>

                <div className='admission-dashboard__section-list'>
                    {sections.map((section, index) => this.renderSectionCard(section, sectionLocksLoaded, index))}
                </div>

                <div className='admission-dashboard__logout-wrapper'>
                    <div className='admission-dashboard__logout-panel'>
                        <div className='admission-dashboard__logout-copy'>
                            <span className='admission-dashboard__logout-kicker'>帳號安全</span>
                            <strong>完成操作後可安全登出</strong>
                            <p>登出後如需繼續填寫，請重新登入學生帳號、密碼。</p>
                        </div>
                        <Link
                            to='/'
                            onClick={this.props.logoutAction}
                            className='admission-dashboard__logout-button'
                        >
                            學生登出
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

    buildSummary(sections, loaded) {
        if (!loaded) {
            return { total: sections.length, completed: 0, submitted: 0, pending: 0 }
        }
        const completed = sections.filter((section) => section.locked).length
        const submitted = sections.filter((section) => !section.locked && section.submitted).length
        const pending = sections.length - completed - submitted
        return { total: sections.length, completed, submitted, pending }
    }

    sectionState(locked, submitted, loaded) {
        if (!loaded) {
            return {
                text: '資料讀取中',
                statusClass: 'is-loading',
                actionLabel: '讀取中',
            }
        }
        if (locked) {
            return {
                text: '註冊組確認完成',
                statusClass: 'is-success',
                actionLabel: '查看內容',
            }
        }
        if (submitted) {
            return {
                text: '家長完成填寫（可修改）',
                statusClass: 'is-info',
                actionLabel: '繼續修改',
            }
        }
        return {
            text: '家長未填寫',
            statusClass: 'is-warning',
            actionLabel: '開始填寫',
        }
    }

    renderSectionCard(section, loaded, index) {
        const state = this.sectionState(section.locked, section.submitted, loaded)
        const style = { animationDelay: `${index * 0.06}s` }

        return (
            <div className={`admission-section-card ${state.statusClass}`} style={style} key={section.key}>
                <div className='admission-section-card__main'>
                    <div>
                        <h3 className='admission-section-card__title'>{section.title}</h3>
                        <p className='admission-section-card__description'>{section.description}</p>
                    </div>
                    <span className={`admission-section-card__status ${state.statusClass}`}>
                        {state.text}
                    </span>
                </div>
                {loaded ? (
                    <Link className='admission-section-card__action' to={section.path}>
                        {state.actionLabel}
                    </Link>
                ) : (
                    <button type='button' disabled className='admission-section-card__action is-disabled'>
                        {state.actionLabel}
                    </button>
                )}
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    const applicationDataImmutable = state.getIn(['ApplicationForAdmissionReducers', 'data']);
    const applicationData = applicationDataImmutable && applicationDataImmutable.toJS
        ? applicationDataImmutable.toJS()
        : (applicationDataImmutable || {});

    const sectionLocksLoaded = Object.prototype.hasOwnProperty.call(applicationData, 'application_ques_check');

    return {
        sectionLocksLoaded,
        applicationLocked: !!applicationData.application_ques_check,
        applicationSubmitted: !!applicationData.application_user_submitted,
        healthLocked: !!applicationData.health_questionnaire_ques_check,
        healthSubmitted: !!applicationData.health_questionnaire_user_submitted,
        parentalLocked: !!applicationData.parental_status_survey_ques_check,
        parentalSubmitted: !!applicationData.parental_status_survey_user_submitted,
        transferLocked: !!applicationData.transfer_student_ques_check,
        transferSubmitted: !!applicationData.transfer_student_user_submitted,
        parentPassLocked: !!applicationData.parent_pass_ques_check,
        parentPassSubmitted: !!applicationData.parent_pass_user_submitted,
    }
}
const mapDispatchToProps = (dispatch) => ({
    getApplicationForAdmission: () => (
        dispatch(getApplicationForAdmission(dispatch))
    ),
    logoutAction: () => (
        dispatch(logoutAction())
    ),
});


export default connect(mapStateToProps, mapDispatchToProps)(DoshboardBox)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DeviseDashboardContainer/DashboardContainer.jsx